<ion-app>
  <div class="div-content" [style.--ion-background-color]="backgroundColor">
    <router-outlet></router-outlet>
  </div>
</ion-app>
